import { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import { animateScroll } from 'react-scroll';
import styled, { useTheme } from 'styled-components';
import Icon from '../Icon';
import { mq } from '~/styles/grid';

const Button = styled.button`
  position: fixed;
  z-index: 996;
  transition:
    bottom 0.25s ease-out,
    opacity 0.25s ease-out,
    bottom 0.25s ease-out;
  bottom: ${(props) =>
    props.visible ? `${props.theme.backToTopBtn.bottom}px` : '-45px'};
  opacity: ${(props) => (props.visible ? '1' : '0')};
  right: ${(props) => props.theme.backToTopBtn.right}px;
  height: 45px;
  width: 45px;

  @media print {
    visibility: hidden;
  }

  @media (${mq.xs}) {
    right: 5px;
  }

  &:hover {
    bottom: 10px;
  }

  svg {
    height: 100%;
    width: 100%;
  }
`;

/**
 * @returns {React.ReactElement} The rendered component
 */
const BackToTopBtn = () => {
  const [isVisible, toggleVisibility] = useState(false);
  const theme = useTheme();

  const handleScroll = debounce(() => {
    if (window.pageYOffset > theme.backToTopBtn.offset) {
      toggleVisibility(true);
    } else {
      toggleVisibility(false);
    }
  }, 250);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return function cleanup() {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  return (
    <Button onClick={() => animateScroll.scrollToTop()} visible={isVisible}>
      <Icon icon={theme.backToTopBtn.icon} />
    </Button>
  );
};

export default BackToTopBtn;
